import { CONTRIBUTOR_VIEW_ACCESS } from '../../../../constants/contributors';

/**
 * @enum REDIRECT_MODE
 * @type {{VIEW_ONLY: string, UPLOAD: string, VIEW_AND_CONTRIBUTE: string}}
 */
export const REDIRECT_MODE = {
  VIEW_ONLY: 'view_only',
  VIEW_AND_CONTRIBUTE: 'view_and_contribute',
  UPLOAD: 'upload',
};

/**
 * Determines the REDIRECT_MODE of AutoContributorSettings.
 *
 * @param {Object} autoContributorSettings The AutoContributorSettings
 * @returns {REDIRECT_MODE}
 */
export const getAutoContributorLinkHandlerRedirectMode =
  autoContributorSettings => {
    if (!autoContributorSettings) {
      return '';
    }

    const hasViewPermission =
      !!autoContributorSettings.view_access &&
      autoContributorSettings.view_access !== CONTRIBUTOR_VIEW_ACCESS.NONE;
    const hasUploadPermission =
      !!autoContributorSettings.upload_access &&
      autoContributorSettings.upload_access !== CONTRIBUTOR_VIEW_ACCESS.NONE;

    if (hasViewPermission && hasUploadPermission) {
      return REDIRECT_MODE.VIEW_AND_CONTRIBUTE;
    }

    if (hasUploadPermission) {
      return REDIRECT_MODE.UPLOAD;
    }

    return REDIRECT_MODE.VIEW_ONLY;
  };
